import {
    GridCallbackDetails,
    GridColDef,
    GridPaginationModel,
    GridRowParams,
    GridSortModel,
} from '@mui/x-data-grid';

import { DataGrid, DataGridCard } from '@barboxx/admin-components';
import {
    NAME_MIN_WIDTH,
    renderPriceEditCell,
    useBusinessSelector,
} from '@barboxx/admin-utils';
import { CustomDrink } from '@barboxx/models';

type Columns = GridColDef<CustomDrink>[];

const COLUMNS: Columns = [
    { field: 'id', headerName: 'Id', width: 70 },
    { field: 'name', headerName: 'Name', width: 200 },
    { field: 'description', headerName: 'Description', width: 200, flex: 1 },
    {
        field: 'basePrice',
        headerName: 'Base Price',
        width: 100,
        align: 'right',
        headerAlign: 'right',
        renderCell: renderPriceEditCell,
    },
    {
        field: 'upCharge',
        headerName: 'Up Charge',
        width: 100,
        align: 'right',
        headerAlign: 'right',
        renderCell: renderPriceEditCell,
    },
    {
        field: 'isAlcoholic',
        headerName: 'Is Alcoholic',
        width: 150,
        type: 'boolean',
    },
    {
        field: 'iShot',
        headerName: 'Is Shot',
        width: 100,
        type: 'boolean',
    },
];

interface Props {
    data: CustomDrink[];
    size: number;
    page: number;
    total: number;
    onRowClick: (id: string) => void;
    onChangeSort: (sort: GridSortModel) => void;
    handleChangePageModel: (
        model: GridPaginationModel,
        details: GridCallbackDetails
    ) => void;
}

export function CustomDrinkTable(props: Props) {
    const {
        data = [],
        total,
        size,
        page,
        onRowClick,
        handleChangePageModel,
        onChangeSort,
    } = props;

    const { businessList } = useBusinessSelector();
    const handleRowClick = (param: GridRowParams) => {
        onRowClick(param.id as string);
    };

    const columns: Columns = [
        {
            field: 'businessId',
            headerName: 'Business ID',
            minWidth: NAME_MIN_WIDTH,
            type: 'singleSelect',
            flex: 1,
            valueOptions: params =>
                businessList.map(business => ({
                    value: business.id,
                    label: business.place.name,
                })) ?? [],
        },
        ...COLUMNS,
    ];

    return (
        <DataGridCard title="Custom Drinks">
            <DataGrid
                rows={data}
                columns={columns}
                paginationModel={{
                    page,
                    pageSize: size,
                }}
                onPaginationModelChange={handleChangePageModel}
                rowCount={total}
                disableColumnMenu
                onRowClick={handleRowClick}
                onSortModelChange={onChangeSort}
            />
        </DataGridCard>
    );
}
